






















import { Component, Prop, Vue } from "vue-property-decorator";
import SmallText from "@/common/components/atoms/SmallText.vue";
import HSpecColumnList from "@/general/components/pages/parts/PointHistoryList/HSpecColumnList.vue";

@Component({
  components: {
    SmallText,
    HSpecColumnList
  }
})
export default class HBorderPanel extends Vue {
  @Prop({ type: [Array, Boolean], default: false }) specListItem!:
    | any[]
    | boolean;
  @Prop({ type: String, default: "m" }) bodyMargin!: string;
}
